import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StreakStateService } from '../shared/services/streak-state.service';

export const wheelGuard: CanActivateFn = (route) => {
  const streakState = inject(StreakStateService);
  const router = inject(Router);

  if (streakState.hideWheel()) {
    router.navigate(['/'], { queryParams: route.queryParams });
    return false;
  }

  return true;
};
